import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import './Testimonial.css';
import zlata from '../../../src/img/Testimonial/zlata.jpg'
import savo from '../../../src/img/Testimonial/savo.png'
import mirko from '../../../src/img/Testimonial/mirko.jpg'
import crni from '../../../src/img/Testimonial/crni.png'
import shape from '../../../src/img/Testimonial/shape-bg.png'




function Testimonial(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const options = {
    loop : true,
    margin: 0,
    nav: true,
    animateIn: "bounceInRight",
    animateOut: "bounceOutRight",
    dots: true,
    autoplay: true,
    smartSpeed: 2000,
    autoplayTimeout:7000,
    responsive: {
        0: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 3
        }
    }
  }

  return (
    <div>
      <ScreenHeading
        title={"Svjedočanstva"}
        subHeading={"Šta naši klijenti kažu o nama"}
      />
      <section className="testimonial-section fade-in" id={props.id}>
        <div className="container">
          <div className="row">
            <OwlCarousel className="owl-carousel" id="testimonial-carousel" {...options}>
              <div className="col-lg-12">
                <div className="testi-item">
                  <div className="testi-comment">
                    <p>
                        <i className="fa fa-qoute-left"/>
                      S ponosom mogu reći da sam učestvovala iniciranju otvaranja ove firme.
                      Imala sam posla sa subjektima u BiH i trebali su mi razni savjeti. 
                      Kada sam vidjela koliko su ovi ljudi precizni, tačni i jasni, rekla sam im ovim se trebate baviti
                      profesionalno.
                      <i className="fa fa-qoute-right"/>
                    </p>
                    <ul className="stars list-unstyled">
                        <li>
                            <i className="fa fa-star"/>
                        </li>
                        <li>
                            <i className="fa fa-star"/>
                        </li> 
                        <li>
                            <i className="fa fa-star"/>
                        </li> 
                        <li>
                            <i className="fa fa-star"/>
                        </li> 
                        <li>
                            <i className="fa fa-star"/>
                        </li>
                    </ul>
                  </div>
                  <div className="client-info">
                    <img src={zlata} alt="no internet"/>
                    <h5>Zlata Žujić</h5>
                    <p>CEO of 007 Security Las Vegas</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="testi-item">
                  <div className="testi-comment">
                    <p>
                        <i className="fa fa-qoute-left"/>
                        Bavim se filmovima i reklamama, tako da nemam puno znanja ni iskustva u pravu i 
                       informatici. Prepustio sam Magni rješavanje problema iz ovih oblasti. Osim kvaliteta rada, oduševilo 
                        me razumjevanje za moju poziciju kao samostalnog preduzetnika i povoljnost usluga. 
                      <i className="fa fa-qoute-right"/>
                    </p>
                    <ul className="stars list-unstyled">
                        <li>
                            <i className="fa fa-star"/>
                        </li>
                        <li>
                            <i className="fa fa-star"/>
                        </li> 
                        <li>
                            <i className="fa fa-star"/>
                        </li> 
                        <li>
                            <i className="fa fa-star"/>
                        </li> 
                        <li>
                            <i className="fa fa-star"/>
                        </li>
                    </ul>
                  </div>
                  <div className="client-info">
                    <img src={savo} alt="no internet"/>
                    <h5>Stefan Tomić</h5>
                    <p>Samostalni preduzetnik</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="testi-item">
                  <div className="testi-comment">
                    <p>
                        <i className="fa fa-qoute-left"/>
                        Sarađujem sa timom Magne od samog početka. Umjesto mene su radili na registraciji,
                        prijavama za podsticaje od strane grada, republike, ali i evropskih institucija. Pomogli su mi i u 
                        smišljanju i snimanju reklama, izradi promo materijala, te za nabavku bilo čega što mi je bilo potrebno. 

                      <i className="fa fa-qoute-right"/>
                    </p>
                    <ul className="stars list-unstyled">
                        <li>
                            <i className="fa fa-star"/>
                        </li>
                        <li>
                            <i className="fa fa-star"/>
                        </li> 
                        <li>
                            <i className="fa fa-star"/>
                        </li> 
                        <li>
                            <i className="fa fa-star"/>
                        </li> 
                        <li>
                            <i className="fa fa-star"/>
                        </li>
                    </ul>
                  </div>
                  <div className="client-info">
                    <img src={crni} alt="no internet"/>
                    <h5>Jovan Milaković Crni</h5>
                    <p>SP Gazda Crni</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="testi-item">
                  <div className="testi-comment">
                    <p>
                        <i className="fa fa-qoute-left"/>
                        Sarađivao sam sa američkim kompanijama u cilju promocije svog sajta na Google rangiranju. Nakon toga sam predao
                        ovaj posao saradnicima iz Magne koji to rade kvalitetnije, ali i jeftinije nego američke kompanije. Od tad
                        ih svima preporučujem. 
                      <i className="fa fa-qoute-right"/>
                    </p>
                    <ul className="stars list-unstyled">
                        <li>
                            <i className="fa fa-star"/>
                        </li>
                        <li>
                            <i className="fa fa-star"/>
                        </li> 
                        <li>
                            <i className="fa fa-star"/>
                        </li> 
                        <li>
                            <i className="fa fa-star"/>
                        </li> 
                        <li>
                            <i className="fa fa-star"/>
                        </li>
                    </ul>
                  </div>
                  <div className="client-info">
                    <img src={mirko} alt="no internet"/>
                    <h5>Mirko Babić</h5>
                    <p>CEO Solid top repairs Los Angeles</p>
                  </div>
                </div>
              </div>


            </OwlCarousel>
          </div>
        </div>
      </section>
      <div className="footer-image">
        <img src={shape} alt="image not responding" />
      </div>
    </div>
  );
}

export default Testimonial;
